
import { Vue, Component, Prop } from "vue-property-decorator";
import vModal from "@/components/vModal.vue";
import { mapState } from "vuex";
import { LocalizationState } from "@/store/modules/LocalizationModule";

@Component({
  components: {
    vModal,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule
    }),
  },
})
export default class vGenericConfirmationModal extends Vue {
  @Prop() showModal!: boolean;
  @Prop() titleTranslationKey!: string;
  @Prop() submitTranslationKey!: string;
  @Prop() cancelTranslationKey!: string;
  @Prop({ default: false }) invertColors!: boolean;

  localizationState: LocalizationState;

  get translations() {
    return this.localizationState.translations;
  }

  handleSubmit() {
    this.$emit("on-submit");
    this.showModal = false;
  }

  closeModal() {
    this.$emit("on-cancel");
    this.showModal = false;
  }
}
